import { postData } from "../common/Apicall";

export const rfqSubmitApi = (data) => {
  const { title, description, quantity, amount, files, type, phoneNumber } = data;

  const formData = new FormData();
  files.forEach((blob) => {
    formData.append("files", blob);
  });
  formData.append("title", title);
  formData.append("description", description);
  formData.append("amount", amount);
  formData.append("quantity", quantity);
  formData.append("type", type);
  formData.append("phoneNumber", phoneNumber);

  return postData("/api/v1/rfq/createRFQ", formData, true);
};
